import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-style: ", ";\n  text-decoration: ", ";\n  color: ", ";\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &:link,\n  &:visited,\n  &:hover,\n  &:active {\n    text-decoration: underline;\n    text-underline-offset: 2px;\n    color: inherit;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { Fragment } from 'react';
import ReactMarkdown from 'react-markdown';
import { styled } from '@acorns/web-components';
import { compose, join, map, pickAll } from 'ramda';
import { addLearnTipToString, hasLearnTip } from './LearnTips';
var StyledLink = styled.a(_templateObject());
export var performSubstitution = function performSubstitution(unformattedString, variables) {
  return (variables !== null && variables !== void 0 ? variables : []).reduce(function (accumulator, variable, index) {
    return accumulator.replace(new RegExp("%".concat(index + 1, "\\$s"), 'g'), variable);
  }, unformattedString);
}; // This is a very brittle and temporary solution
// TODO: Deprecate this once we have completely transitioned to styled string.

export var performFormatting = function performFormatting(displayString, variableColor) {
  var formattedString;

  if (variableColor) {
    formattedString = displayString.replace('**', "<b><font color=\"".concat(variableColor, "\">")).replace('**', '</font></b>').replace('**', "<b><font color=\"".concat(variableColor, "\">")).replace('**', '</font></b>');
  } else {
    formattedString = displayString.replace('**', '<b>').replace('**', '</b>');
  }

  return formattedString;
};
export var getDisplayString = function getDisplayString(_ref) {
  var _ref$strings = _ref.strings,
      strings = _ref$strings === void 0 ? {} : _ref$strings,
      key = _ref.key,
      _ref$variables = _ref.variables,
      variables = _ref$variables === void 0 ? [] : _ref$variables,
      _ref$variableColor = _ref.variableColor,
      variableColor = _ref$variableColor === void 0 ? '' : _ref$variableColor;
  var value = strings[key] || '';
  var substitutedString = performSubstitution(value, variables);
  return performFormatting(substitutedString, variableColor);
}; // TODO: Deprecate this once we have complete transitioned to StyledString

export var getMarkdownString = function getMarkdownString(_ref2) {
  var strings = _ref2.strings,
      keys = _ref2.keys,
      _ref2$variables = _ref2.variables,
      variables = _ref2$variables === void 0 ? [] : _ref2$variables;
  var target = pickAll(_toConsumableArray(keys), strings);

  var getDisplayValue = function getDisplayValue(key) {
    return (target === null || target === void 0 ? void 0 : target[key]) || '';
  };

  return performSubstitution(compose(join(' '), map(getDisplayValue))(keys), variables);
};
var Container = styled.span(_templateObject2());
var StyledPart = styled.span(_templateObject3(), function (props) {
  return props.bold !== undefined ? props.bold : 'unset';
}, function (props) {
  return props.italic ? 'italic' : 'unset';
}, function (props) {
  return props.underlined ? 'underline' : 'unset';
}, function (props) {
  return props.color ? props.color : 'unset';
}, function (props) {
  return props.gradient && "\n      background-image: ".concat(props.gradient, ";\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n  ");
});
var asteriskDelimiter = /(\*{2}.*?\*{2})/gm;
var linkDelimiter = /(\[.*?\))/gm;
var delimiter = /(\*{2}.*?\*{2})|(\[.*?\))/gm;
export var formatRemoteString = function formatRemoteString(unformattedString, renderKey, localizedStrings, learnTips, modifiers, wrappers, nodes, screen) {
  var splitString = unformattedString.split(delimiter).filter(Boolean);
  var partIndex = 0;
  var stringParts = splitString.filter(Boolean).reduce(function (acc, str, index) {
    var hasMatch = str.match(delimiter);
    var indexedRenderKey = "".concat(renderKey, "-").concat(index);

    if (hasLearnTip(str)) {
      return [].concat(_toConsumableArray(acc), [/*#__PURE__*/React.createElement("span", {
        key: indexedRenderKey
      }, addLearnTipToString(str, localizedStrings, learnTips, screen))]);
    } else if (hasMatch) {
      var hasAsteriskDelimMatch = str.match(asteriskDelimiter);
      var hasLinkDelimMatch = str.match(linkDelimiter);

      if (hasAsteriskDelimMatch) {
        var _wrappers$partIndex$c, _wrappers$partIndex, _wrappers$partIndex$p, _wrappers$partIndex2;

        var node = nodes === null || nodes === void 0 ? void 0 : nodes[partIndex]; // If node exists, insert and return since it is meant to override modifiers and wrappers.

        if (node) {
          partIndex++;
          return [].concat(_toConsumableArray(acc), [node]);
        }

        var StyledWrapper = (_wrappers$partIndex$c = wrappers === null || wrappers === void 0 ? void 0 : (_wrappers$partIndex = wrappers[partIndex]) === null || _wrappers$partIndex === void 0 ? void 0 : _wrappers$partIndex.component) !== null && _wrappers$partIndex$c !== void 0 ? _wrappers$partIndex$c : Fragment;
        var wrapperProps = (_wrappers$partIndex$p = wrappers === null || wrappers === void 0 ? void 0 : (_wrappers$partIndex2 = wrappers[partIndex]) === null || _wrappers$partIndex2 === void 0 ? void 0 : _wrappers$partIndex2.props) !== null && _wrappers$partIndex$p !== void 0 ? _wrappers$partIndex$p : {};
        var decoratorProps = (modifiers === null || modifiers === void 0 ? void 0 : modifiers[partIndex]) || [];
        partIndex++;
        return [].concat(_toConsumableArray(acc), [/*#__PURE__*/React.createElement(StyledWrapper, _extends({
          key: indexedRenderKey
        }, wrapperProps), /*#__PURE__*/React.createElement(StyledPart, decoratorProps, str.slice(2, str.length - 2)))]);
      } else if (hasLinkDelimMatch) {
        var linkSplit = str.split(']('); // "[link](https://google.com)"

        var textPart = linkSplit[0]; // "[link"

        var urlPart = linkSplit[1]; // "https://google.com)"

        var text = textPart.slice(1); // "link"

        var url = urlPart.slice(0, urlPart.length - 1); // "https://google.com"

        return [].concat(_toConsumableArray(acc), [/*#__PURE__*/React.createElement(StyledLink, {
          href: url,
          target: "__blank"
        }, text)]);
      }
    }

    return [].concat(_toConsumableArray(acc), [/*#__PURE__*/React.createElement("span", {
      key: indexedRenderKey
    }, str)]);
  }, []);
  return stringParts;
}; // TODO: Deprecate this once we have complete transitioned to StyledString

export var Markdown = function Markdown(props) {
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(ReactMarkdown, {
    source: getMarkdownString(props)
  }));
};